import React, { useState } from 'react'
import { Typography, withStyles } from '@material-ui/core'
import styles from './styles'
import { patchSetting } from 'src/hooks/useCardSettings'
import { useDispatch, useSelector } from 'react-redux'
import { CoreTextField } from 'src/components/core'
import { editorLoading } from 'src/reducers/card/action'

const SuccessRate = props => {
  const dispatch = useDispatch()
  const { classes, badgeSettings, settings } = props
  const editorLoadingState = useSelector(state => state.card.editorLoading)
  const [percentage, setPercentage] = useState(badgeSettings.successRate)

  const handlePercentage = e => {
    let percentage = e
    if (e > 100) {
      percentage = 100
    }
    setPercentage(percentage)
  }

  const patchPercentage = e => {
    dispatch(editorLoading())

    let percentage = e
    if (e > 100) {
      percentage = 100
    }

    patchSetting(
      dispatch,
      settings.cardId,
      settings.id,
      'badge',
      JSON.stringify({
        ...badgeSettings,
        successRate: percentage,
      }),
      () => {
        setTimeout(() => {
          dispatch(editorLoading())
        }, 3000)
      },
    )
  }

  const handleBlur = event => {
    if (editorLoadingState) {
      setTimeout(() => {
        patchPercentage(event.target.value)
      }, 2000)
    } else {
      patchPercentage(event.target.value)
    }
  }

  return (
    <div className={classes.root}>
      <Typography className={classes.heading}>
        Award the badge if the success rate equals or exceeds
      </Typography>
      <CoreTextField
        size="small"
        InputProps={{
          endAdornment: <Typography>%</Typography>,
        }}
        value={percentage}
        onChange={event => handlePercentage(event.target.value)}
        onBlur={handleBlur}
        className={classes.textField}
        type="number"
        marginTop={false}
      />
    </div>
  )
}

export default withStyles(styles)(SuccessRate)
